import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

import Layout from '@/layout'

const initRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },

  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true
  },

  //隐私政策-云售后
  {
    path: '/smsPrivacyPolicy',
    component: () => import('@/views/privacyPolicy/smsPrivacyPolicy'),
    hidden: true
  },
  //隐私政策-易派
  {
    path: '/yipaiPrivacyPolicy',
    component: () => import('@/views/privacyPolicy/yipaiPrivacyPolicy'),
    hidden: true
  },
  //隐私政策-云派工
  {
    path: '/cloudDispatchPrivacyPolicy',
    component: () => import('@/views/privacyPolicy/cloudDispatchPrivacyPolicy'),
    hidden: true
  },
  //隐私政策-自助服务
  {
    path: '/selfServicePrivacyPolicy',
    component: () => import('@/views/privacyPolicy/selfServicePrivacyPolicy'),
    hidden: true
  },
  //用户协议-自助服务
  {
    path: '/selfServiceUserAgreement',
    component: () => import('@/views/userAgreement/selfServiceUserAgreement'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/home',
    name: 'Home',
    hidden: true,
    children: [{
      path: 'home',
      component: () => import('@/views/home/index')
    }]
  },
  // 首页看板 - 所有用户均可访问（包括无菜单权限的新账户）
  {
    path: '/homeBoard',
    component: Layout,
    redirect: '/homeBoard/index',
    name: 'HomeBoard',
    hidden: true,
    children: [
      {
        path: 'index',
        component: () => import('@/views/homeBoard/index'),
        meta: { title: '首页' }
      }
    ]
  },
]

// 弃用，在系统菜单管理中配置
// const authControlRoutes = [
//   {
//     path: '/homeBoard',
//     component: Layout,
//     redirect: '/homeBoard',
//     meta: { title: '首页', icon: 'dataicon.png' },
//     children: [
//       {
//         path: 'index',
//         component: () => import('@/views/homeBoard/index'),
//         meta: { title: '首页', icon: 'dataicon.png' }
//       }
//     ]
//   },
//   {
//     path: '/user',
//     component: Layout,
//     meta: { title: '客户管理', icon: 'usericon.png' },
//     children: [
//       {
//         path: '/user/userGet',
//         name: '/user/userGet',
//         component: () => import('@/views/user/userGet'),
//         meta: { title: '客户查询', }
//       },
//       {
//         path: '/user/userAdd',
//         name: '/user/userAdd',
//         component: () => import('@/views/user/userAdd'),
//         meta: { title: '客户创建', }
//       },
//       {
//         path: '/user/userEdit',
//         name: '/user/userEdit',
//         hidden: true,
//         component: () => import('@/views/user/userEdit'),
//         meta: { title: '客户创建', }
//       },
//       {
//         path: '/user/userCheck',
//         name: '/user/userCheck',
//         hidden: true,
//         component: () => import('@/views/user/userCheck'),
//         meta: { title: '客户创建', }
//       },
//     ]
//   },
//   {
//     path: '/order',
//     component: Layout,
//     redirect: '/order',
//     meta: { title: '订单管理', icon: 'ordericon.png' },
//     children: [
//       {
//         path: '/order/orderGet',
//         name: '/order/orderGet',
//         component: () => import('@/views/order/orderGet'),
//         meta: { title: '用户下单查询', }
//       }, {
//         path: '/order/batchOrderGet',
//         name: '/order/batchOrderGet',
//         component: () => import('@/views/order/batchOrderGet'),
//         meta: { title: '批量下单查询', }
//       },
//       {
//         path: "/order/valuation",
//         name: "/order/valuation",
//         component: () => import("@/views/order/valuation"),
//         meta: { title: "估价订单管理" }
//       },
//       {
//         path: "/order/valuationEdit",
//         name: "/order/valuationEdit",
//         component: () => import("@/views/order/valuationEdit"),
//         meta: { title: "估价订单详情" }
//       },
//       {
//         path: '/order/orderAdd',
//         name: '/order/orderAdd',
//         component: () => import('@/views/order/orderAdd'),
//         meta: { title: '订单创建', }
//       },
//       {
//         path: '/order/orderCheck',
//         name: '/order/orderCheck',
//         hidden: true,
//         component: () => import('@/views/order/orderCheck'),
//         meta: { title: '订单查看', }
//       },
//       {
//         path: '/order/orderEdit',
//         name: '/order/orderEdit',
//         hidden: true,
//         component: () => import('@/views/order/orderEdit'),
//         meta: { title: '订单编辑', }
//       }
//     ]
//   },
//   {
//     path: '/oldForNewService',
//     component: Layout,
//     redirect: '/oldForNewService',
//     meta: { title: '以旧换新管理', icon: 'setupicon.png' },
//     children: [
//       {
//         path: '/oldForNewService/inventory',
//         name: '/oldForNewService/inventory',
//         component: () => import('@/views/oldForNewService/inventory'),
//         meta: { title: '网点旧机库存', }
//       },
//       {
//         path: '/oldForNewService/order',
//         name: '/oldForNewService/order',
//         component: () => import('@/views/oldForNewService/order'),
//         meta: { title: '旧机回收订单', }
//       },
//       {
//         path: '/oldForNewService/orderDetail',
//         name: '/oldForNewService/orderDetail',
//         component: () => import('@/views/oldForNewService/orderDetail'),
//         meta: { title: '旧机回收订单详情', }
//       },
//       {
//         path: '/oldForNewService/searchOld',
//         name: '/oldForNewService/searchOld',
//         component: () => import('@/views/oldForNewService/searchOld'),
//         meta: { title: '旧机查询', }
//       },
//       {
//         path: '/oldForNewService/searchOldDetail',
//         name: '/oldForNewService/searchOldDetail',
//         component: () => import('@/views/oldForNewService/searchOldDetail'),
//         meta: { title: '旧机查询-结算单', }
//       },
//       {
//         path: '/oldForNewService/searchOldSettlementDetail',
//         name: '/oldForNewService/searchOldSettlementDetail',
//         component: () => import('@/views/oldForNewService/searchOldSettlementDetail'),
//         meta: { title: '旧机查询-结算单明细', }
//       },
//       {
//         path: '/oldForNewService/carrier',
//         name: '/oldForNewService/carrier',
//         component: () => import('@/views/oldForNewService/carrier'),
//         meta: { title: '承运商管理', }
//       },
//       {
//         path: '/oldForNewService/carrierDetail',
//         name: 'carrierDetail',
//         component: () => import('@/views/oldForNewService/carrierDetail'),
//         meta: { title: '保证金管理' },
//         props: true
//       },
//       {
//         path: '/oldForNewService/carrierArea',
//         name: '/oldForNewService/carrierArea',
//         component: () => import('@/views/oldForNewService/carrierArea'),
//         meta: { title: '承运商区域分配', }
//       },
//       {
//         path: '/oldForNewService/warehouse',
//         name: '/oldForNewService/warehouse',
//         component: () => import('@/views/oldForNewService/warehouse'),
//         meta: { title: '归集仓管理', }
//       },
//       {
//         path: '/oldForNewService/warehouseArea',
//         name: '/oldForNewService/warehouseArea',
//         component: () => import('@/views/oldForNewService/warehouseArea'),
//         meta: { title: '归集区域分配', }
//       },
//       {
//         path: '/oldForNewService/oldValuation',
//         name: '/oldForNewService/oldValuation',
//         component: () => import('@/views/oldForNewService/oldValuation'),
//         meta: { title: '旧机价值管理', }
//       }
//     ]
//   },
//   {
//     path: '/dataBoard',
//     component: Layout,
//     redirect: '/dataBoard',
//     meta: { title: '数据看板', icon: 'dataicon.png' },
//     children: [
//       {
//         path: 'index',
//         component: () => import('@/views/dataBoard/index'),
//         meta: { title: '经营看板', icon: 'dataicon.png' }
//       }
//     ]
//   },
//   {
//     path: '/system',
//     component: Layout,
//     redirect: '/system',
//     meta: { title: '系统管理', icon: 'setupicon.png' },
//     children: [
//       {
//         path: '/system/menuManage',
//         name: '/system/menuManage',
//         component: () => import('@/views/system/menuManage'),
//         meta: { title: '菜单管理', }
//       },
//       {
//         path: '/system/orgManage',
//         name: '/system/orgManage',
//         component: () => import('@/views/system/orgManage'),
//         meta: { title: '组织管理', }
//       },
//       {
//         path: '/system/roleAuth',
//         name: '/system/roleAuth',
//         component: () => import('@/views/system/roleAuth'),
//         meta: { title: '角色权限管理', }
//       },
//       {
//         path: '/system/adminGet',
//         name: '/system/adminGet',
//         component: () => import('@/views/system/adminGet'),
//         meta: { title: '账号查询', }
//       },
//       {
//         path: '/system/masterFile',
//         name: '/system/masterFile',
//         component: () => import('@/views/system/masterFile'),
//         meta: { title: '回收人员档案', }
//       }
//     ]
//   },
//   {
//     path: '/recoveryManagement',
//     component: Layout,
//     redirect: '/recoveryManagement',
//     meta: { title: '回收管理', icon: 'setupicon.png' },
//     children: [
//       {
//         path: '/recoveryManagement/areaManagement',
//         name: '/recoveryManagement/areaManagement',
//         component: () => import('@/views/recoveryManagement/areaManagement'),
//         meta: { title: '区域展示价格管理', }
//       },
//       {
//         path: '/recoveryManagement/actualPriceRecovery',
//         name: '/recoveryManagement/actualPriceRecovery',
//         component: () => import('@/views/recoveryManagement/actualPriceRecovery'),
//         meta: { title: '实际价格回收管理', }
//       }
//     ]
//   }
// ]

export const constantRouterMap = [
  ...initRoutes,
  // ...authControlRoutes
]

const createRouter = new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})

const router = createRouter
// 重置基础路由
export const resetRouter = () => {
  const newRouter = new Router({
    mode: 'history',
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRouterMap
  });
  router.matcher = newRouter.matcher;
}

export default router;




// WEBPACK FOOTER //
// ./src/router/index.js